import Modal from "../_bootstrapModalExtensions";
import NotificationUtil from "../_notificationUtil";

import * as Url from "../Utils/UrlUtil";
import * as Layout from "../Utils/LayoutUtil";

import * as GAUtil from "../_google_analytics";
import Interfaces from "../_interfaces";

var ActionViewTitle: string = 'cselekmények időrendi nézete';
var ActionViewTooltip: string = 'Az eljárási cselekmények időrendi sorrendben jelennek meg. Például a hiánypótlási felhívás és a válasz két külön sorban jelenik meg.';
var ProcessAndActionViewTitle: string = 'cselekmények csoportosított nézete';
var ProcessAndActionViewTooltip: string = 'Az összetartozó eljárási cselekmények összefűzve jelennek meg. Például a hiánypótlási felhívás és válasz egy sorban jelenik meg, a sort lenyitva jelennek meg a részletek.';

var stateMap: { [tableName: string]: boolean; } = {};

export function SubProcessAndActionListToggleDetailRow() {

    var table = window["SubProcessAndActionListDetailGrid"];
    var expandButton = $("#expand-collapse-toggle");

    ToggleDetailRow(table, expandButton, false);
}

function ToggleDetailRow(table: MVCxClientGridView, button: JQuery, defaultStateIsOpen: boolean) {
    var currentStateIsOpen = stateMap[table.name] || defaultStateIsOpen;

    if (currentStateIsOpen) {
        table.CollapseAllDetailRows();
        button.text("Mindet kinyit");

        stateMap[table.name] = false;
    } else {
        table.ExpandAllDetailRows();
        button.text("Mindet becsuk");

        stateMap[table.name] = true;
    }
}

var isFlatViewInitialized: boolean = false;
export function ShowProcessActionFlatView() {
    // Keresőmező és nézet cím csere
    $('#searchpanel-for-process-and-action-list').addClass('searchpanel-hide');
    $('#searchpanel-for-action-list').removeClass('searchpanel-hide');

    $('#process-action-view-title').text(ActionViewTitle);
    $('#process-action-view-title-tooltip').attr("title", ActionViewTooltip);

    $("#show-all-addressee").show();
    $("#expand-collapse-toggle").hide();

    if (!isFlatViewInitialized) {
        isFlatViewInitialized = true;

        var table: MVCxClientGridView = window["ActionListForProcess"];
        table.PerformCallback({ loadData: true });
    }

    $('#page-content-flat').show();
    $('#page-content-hierarchial').hide();

    $('#action-list').addClass("active");
    $("#process-and-action-list").removeClass("active");

    initActionListPageHeader();

    // Analytics kód
    if (!Layout.IsOnGreenSide()) {
        try {
            TimerForProcessActionViews.FinishTiming();
            TimerForProcessActionViews.StartTiming('Kérelmezői oldal táblázatai', 'Cselekmények fül (' + $(this).attr('title') + ')', 'Táblázat nézegetésére szánt idő (másodpercben)');

            ProcessActionViewName = $(this).attr('title');
        } catch (err) {
            console.log("analytics hiba: " + err);
        }
    }
}

var isHierarchialViewInitialized: boolean = false;
export function ShowProcessActionHierarchicalView() {
    // Keresőmező és nézet cím csere
    $('#searchpanel-for-action-list').addClass('searchpanel-hide');
    $('#searchpanel-for-process-and-action-list').removeClass('searchpanel-hide');

    $('#process-action-view-title').text(ProcessAndActionViewTitle);
    $('#process-action-view-title-tooltip').attr("title", ProcessAndActionViewTooltip);

    $("#show-all-addressee").hide();
    $("#expand-collapse-toggle").show();

    if (!isHierarchialViewInitialized) {
        isHierarchialViewInitialized = true;
        var table: MVCxClientGridView = window["SubProcessAndActionListDetailGrid"];
        table.PerformCallback({ loadData: true });
    }

    $('#page-content-flat').hide();
    $('#page-content-hierarchial').show();

    $('#action-list').removeClass("active");
    $("#process-and-action-list").addClass("active");

    initActionListPageHeader();

    // Analytics kód
    if (!Layout.IsOnGreenSide()) {

        try {
            TimerForProcessActionViews.FinishTiming();
            TimerForProcessActionViews.StartTiming('Kérelmezői oldal táblázatai', 'Cselekmények fül (' + $(this).attr('title') + ')', 'Táblázat nézegetésére szánt idő (másodpercben)');

            ProcessActionViewName = $(this).attr('title');
        } catch (err) {
            console.log("analytics hiba: " + err);
        }
    }
}

function initActionListPageHeader() {
    if ($("#action-list").hasClass("active")) {
        $("#process-action-page-title").html('<p>Cselekmények időrendi nézete <span class="icon-ico-questionmark-circle-o font-size-1-5 font-weight-bold" data-toggle="tooltip" title="A cselekményeket egyesével időrendi sorrendben tekintheti át"></span></span></p>');
    } else {
        $("#process-action-page-title").html('<p>Cselekmények csoportosított nézete <span class="icon-ico-questionmark-circle-o font-size-1-5 font-weight-bold" data-toggle="tooltip" title="Az összetartozó cselekményláncok egyben látszanak pl.: szakhatósági megkeresés"></span></p>');
    }
}

export function ShowAllAddresseeForProcessActionFlatView() {
    // show all addresee button logic
    var ShowAllAddresseeButton = $("#show-all-addressee");

    ShowAllAddresseeButton.toggleClass("active");

    if (ShowAllAddresseeButton.hasClass("active")) {
        ShowAllAddresseeButton.text("Összes címzett elrejtése");
    } else {
        ShowAllAddresseeButton.text("Összes címzett megjelenítése");
    }

    var grid: MVCxClientGridView = window["ActionListForProcess"];
    grid.Refresh();
}

export function OnBeginCallbackShowAddresseeList(s, e) {
    var isActiveShowAllAddresseeButton = $("#show-all-addressee").hasClass("active");

    e.customArgs['showAddresseeList'] = isActiveShowAllAddresseeButton;
}

var TimerForMainTable: GAUtil.GoogleAnalyticsTimingHelper;
var TimerForProcessActionViews: GAUtil.GoogleAnalyticsTimingHelper;
var ProcessActionViewName: string;

export function InitializeProcessViewTimers(s: MVCxClientPageControl, e: ASPxClientEventArgs) {
    TimerForMainTable = new GAUtil.GoogleAnalyticsTimingHelper();
    TimerForProcessActionViews = new GAUtil.GoogleAnalyticsTimingHelper();
    ProcessActionViewName = 'Cselekmények időrendi nézete';

    GAUtil.Analytics_Init(s, e, ProcessActionViewName, TimerForMainTable, TimerForProcessActionViews, 'Hatósági oldal táblázatai');
}

export function ActiveTabChangedHelper(s: MVCxClientPageControl, e: ASPxClientEventArgs, category: string) {
    GAUtil.Analytics_ActiveTabChanged(s, e, ProcessActionViewName, TimerForMainTable, TimerForProcessActionViews, category);
}

export function InitializeProcessActionsTable(s: MVCxClientPageControl, e: ASPxClientEventArgs) {
    // If both tables are available (to the current user, based on his login type), initialize the first one (the "new" one, the default one, we want every user to use this)
    // Else not much we can do, only one thing is available, use that
    var isCurrentUserAvailable: boolean = window.ETDR_RD.appConfig["User.IsCurrentUserAvailable"];
    var isOfficialUser: boolean = window.ETDR_RD.appConfig["User.IsOfficialUser"];
    var isIntegratedCustomerService: boolean = window.ETDR_RD.appConfig["User.IsIntegratedCustomerService"];

    var showFlatViewByDefault = isCurrentUserAvailable && !isOfficialUser && !isIntegratedCustomerService;

    if (showFlatViewByDefault) {
        ShowProcessActionFlatView();
    }
    else {
        ShowProcessActionHierarchicalView();
    }
}

export function HighlightRows() {
    $(".highlight-connected-process-actions").click(function (event: JQuery.Event) {
        event.preventDefault();
        event.stopPropagation();

        let gridName: string = $(this).data("gridname");
        let parentid: number = $(this).data("parentid");

        // table object
        let grid = window[gridName];

        let rowCount = grid.GetVisibleRowsOnPage();

        for (var i = 0; i < rowCount; ++i) {
            let parentIdForCurrentRow = +grid.GetRowKey(i).split('|')[1];

            // current row object
            let currentRow = $(grid.GetRow(i));
            let isHighLightedBefore = currentRow.children().hasClass('highlight-row');

            if (parentIdForCurrentRow == parentid && !isHighLightedBefore) {
                currentRow.children().addClass('highlight-row');
                currentRow.find(".highlight-icon").removeClass("icon-ico-link").addClass("icon-ico-unlink");
            }
            else {
                currentRow.children().removeClass('highlight-row');
                currentRow.find(".highlight-icon").removeClass("icon-ico-unlink").addClass("icon-ico-link");
            }
        }
    });
}

export function MoreAddresseeList() {
    $(".more-addressee-link").click(function (event: JQuery.Event) {
        event.stopPropagation();
        event.preventDefault();

        let processActionId = $(this).data("actionid");
        let urlTemplate = window.ETDR_RD.appConfig["UrlTemplate.GetAddresseeListPartial"] as string;
        let url = Url.createUrlFromTemplate(urlTemplate, { actionId: processActionId });

        $.get(
            url,
            function (response: any, status: JQuery.Ajax.ErrorTextStatus, xhr: JQuery.jqXHR) {
                Modal.showAlertWindow(response, 'Címzett lista');
            })
    });
}

export function ProcessActionListOnRowClick(s: ASPxClientGridView, e: ASPxClientGridViewRowClickEventArgs) {
    let htmlEvent = e.htmlEvent as Event;
    let target = htmlEvent.target as Element;

    if (target.classList.contains('dxgvCommandColumn_ETDRTheme')
        || target.classList.contains('action-row-actions')
        || target.classList.contains('dxgvDetailButton_ETDRTheme')
        || target.classList.contains('fa')
    ) {
        return;
    }

    // If the expand button "+" was clicked, consider this event handled and bail
    //if (ExpandDetailRowOnCellClick(s, e)) {
    //    return;
    //}

    // If the DX bug which is caused by the commented out code above will be fixed, this should be deleted.
    if (target.classList.contains('dxgvDetailButton_ETDRTheme')) {
        return;
    }

    var str = s.GetRowKey(e.visibleIndex);
    var key = str.replace("|", "-");
    var obj = $('#' + key)[0];

    if (obj) {
        var url = obj.getAttribute('data-dblClickUrl');
        window.location.replace(url);
    }
}

export function DeleteProcessAction(event: JQuery.ClickEvent) {
    let $deleteBtn: JQuery = $(event.currentTarget);
    let processActionId: string = $deleteBtn.data('process-action-id');
    let processId: string = $deleteBtn.data('process-id');
    let deleteUrl: string = window.ETDR_RD.appConfig["UrlAction.DeleteProcessAction"]
    let listActionUrl: string = window.ETDR_RD.appConfig["UrlAction.SubProcessAndActionListUrl"];

    Modal.showConfirmationWindowAsync(
        "Biztosan törli a cselekményt?",
        "Cselekmény törlése",
        () => {
            $.ajax({
                url: deleteUrl,
                method: 'POST',
                data: { id: processActionId },
                headers: { Accept: 'application/json' }
            })
                .done((response: Interfaces.DeleteProcessActionJsonResponse) => {
                    if (response.success) {
                        let div: JQuery = $('#detailAction' + response.subProcessId);

                        div.load(listActionUrl, { 'processId': processId, 'subProcessId': response.subProcessId });

                        // If the deleted ProcessAction was the only one, the entire page need to be reloaded,
                        // because in this case the entire tab is hidden on the blue side
                        if (response.needPageRefresh) {
                            window.location.reload();
                        } else {
                            RefreshProcessActionListGrid();
                        }
                    } else {
                        NotificationUtil.Error(response.message, "A cselekmény törlése sikertelen!");
                    }
                })
                .fail((jqXHR: JQueryXHR) => {
                    NotificationUtil.Error('Hiba történt a cselekmény törlése során.');
                });

            return false;
        },
        () => { return false; },
        'Törlés',
        'Mégsem'
    );
}

export function RefreshProcessActionListGrid(): void {
    let viewName: string = 'ActionListForProcess';
    const isViewVisible: boolean = $('#' + viewName).is(':visible');
    const processActionListGrid: MVCxClientGridView = window[viewName] as MVCxClientGridView;

    if (processActionListGrid && isViewVisible) {
        processActionListGrid.Refresh();
    } else {
        viewName = 'SubProcessAndActionListDetailGrid';
        const subProcessAndProcessActionListGrid: MVCxClientGridView = window[viewName] as MVCxClientGridView;

        if (subProcessAndProcessActionListGrid) {
            subProcessAndProcessActionListGrid.Refresh();
        }
    }
}

jQuery(() => {
    $(document).on('click', '.delete-process-action-btn', (event: JQuery.ClickEvent) => {
        DeleteProcessAction(event);
    });

    $(document).on('click', '.open-process-action', (event: JQuery.ClickEvent) => {
        location.href = $(event.currentTarget).data('href');
    });

    $(document).on('click', '.view-filing-pdf-url', (event: JQuery.ClickEvent) => {
        location.href = $(event.currentTarget).data('href');
    });
});
